namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class PoPurInvoiceDtAppEditor extends Serenity.Extensions.GridEditorBase<PoPurInvoiceDtRow> {
        protected getColumnsKey() { return "Purchase.PoPurInvoiceDtApp"; }
        protected getDialogType() { return PoPurInvoiceDtDialog; }
        protected getLocalTextPrefix() { return PoPurInvoiceDtRow.localTextPrefix; }

        public qnNo: number;

        public myPassValue: string;
        public supid: string;
        public totalamt: number;
        

        public whsid: string;
        public sumaloamt: number;

        public salevattype: string;
        private _disamt: number;
        private _whsdt: string;
        private _sup: string;
        private _totals: number;
        private _vat: string;

        private _salevattype: string;

        private _appfg: boolean;



        constructor(container: JQuery) {
            super(container);

        }

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
            // let self = this;
            // self.toolbar.findButton('add-button').text('สร้างรายการ');
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)

            // buttons.push(
            //     {
            //         title: Q.text("สร้างรายการ"),	// *** Get button text from translation
            //         cssClass: 'button-new',
            //         icon: 'fa-add',
            //         onClick: () => {

            //             if (Q.isEmptyOrNull(this.supid)) {
            //                 Q.warning("Choose Supplier Frist!!")
            //             } else {
            //                 // console.log(this.supid)
            //                 // console.log(this.supid +"sup" + this.whsid)
            //                 this.createEntityDialog(this.getItemType(), dlg => {


            //                     var dialog = dlg as PoPurInvoiceDtDialog;
            //                     dialog.onSave = (opt, callback) => this.save(opt, callback);
            //                     var entity = this.getNewEntity() as PoPurInvoiceDtRow;

            //                     entity.SysDocNo = this.myPassValue
            //                     entity.SupplierId = this.supid
            //                     entity.WhsId = this.whsid
            //                     entity.SalesVatTypes  = this.salevattype



            //                     dialog.loadEntityAndOpenDialog(entity, false);
            //                 }

            //                 );
            //             }
            //         },
            //     }
            // );
            // buttons.push(
            //     {
            //         title: Q.text("Refresh"),	// *** Get button text from translation
            //         cssClass: 'button-refresh',
            //         icon: 'fa-refresh',
            //         onClick: () => {

            //             this.refresh();
            //         },
            //     }
            // );



            return buttons;
        }
        public DisableAddButton() {
            this.toolbar.findButton('add-button').toggleClass('disabled', true);
            Serenity.EditorUtils.setReadonly(this.element.find('.editor'), true);
        }





        protected createSlickGrid() {
            var grid = super.createSlickGrid();
            //--set new set of grid columns---
            //--get content width
            // let ele = document.getElementsByClassName("grid-container");
            // var bordermg = 60;
            // var eleWidth = ele.item(0).clientWidth - bordermg * 5;
            // var totalcolw = 0;

            // let propItems = this.getPropertyItems();
            // let items = this.getColumns();
            // items.forEach((item, idx) => {
            //     let pItem = Q.tryFirst(propItems, x => x.name == item.sourceItem.name);
            //     totalcolw += pItem.width;

            // });
            // items.forEach((item, idx) => {
            //     let pItem = Q.tryFirst(propItems, x => x.name == item.sourceItem.name);
            //     pItem.resizable = true;
            //     pItem.width = (eleWidth / totalcolw) * pItem.width;


            // });

            // let c = this.postProcessColumns(this.propertyItemsToSlickColumns(propItems));
            // grid.setColumns(c);
            // grid.resizeCanvas();

            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            this.view.setSummaryOptions({
                aggregators: [
                    new Slick.Aggregators.Sum('Qty'),
                    new Slick.Aggregators.Sum('BeforeDiscAmt'),
                    new Slick.Aggregators.Sum('DiscAmt'),
                    new Slick.Aggregators.Sum('AlocalteDiscAmt'),
                    new Slick.Aggregators.Sum('ItemAmt'),
                    new Slick.Aggregators.Sum('ItemVatAmt'),
                    new Slick.Aggregators.Sum('ItemExVatAmt')
                ]
            });
            return grid;
        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = true;
            // opt.frozenColumn = 1;
            return opt;
        }

        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.localSort = true;
            return opt;
        }

        protected usePager() {
            return false;
        }

        public get DisAlocate(): number { return this._disamt; }
        public get WhsId(): string { return this._whsdt; }

        public get sup(): string { return this._sup; }
        public get TotalAmt_(): number { return this._totals; }
        public get Vatchange(): string { return this._vat; }
        public get salevatetype(): string { return this._salevattype; }

        public get Appfg(): boolean { return this._appfg; }

        set Appfg(value: boolean) {
            if (this._appfg != value) {     
                if(value=true){    
                this.toolbar.findButton('button-new').toggleClass('disabled', true);} else {
                    this.toolbar.findButton('button-new').toggleClass('disabled', false);
                }
            }
        }

        set sup(value: string) {
            if (this._sup != value) {
                console.log("whsid: " + value);
                //  var row =  this.view.getRows();
                this.clearDataGrid();
                this.refresh();
            }
        }

        set TotalAmt_(value: number) {
            // if (this._totals != value) {
            this.totalamt = value
            console.log("too:" + this.totalamt)
            // }
        }

        set salevatetype(value: string) {
            if (this._salevattype != value) {
                this.salevattype = value
                var row = this.view.getRows();
                this.clearDataGrid();
                var i = 0;
                var sum = 0;

                for (var po of row) {
                    i++;
                    var vatrate = 0.00;
                    var vatcode = '';
                    var vat = 0
                    var exvat = 0

                    if (po.VatType != "N") {
                        vatcode = value
                        vatrate = Administration.CsVatCodeRow.getLookup().itemById[value].VatRate
                        if (this.salevattype == "I") {
                            vat = (po.ItemNetAmt * po.VatRate) / (100 + po.VatRate);
                            exvat = po.ItemNetAmt - vat;
                        } else {
                            vat = po.ItemNetAmt * (po.VatRate / 100);
                            exvat = po.ItemNetAmt;
                        }
                    } else {
                        vatcode = po.VatCode
                        vatrate = po.VatRate
                        vat = po.ItemVatAmt
                        exvat = po.ItemExVatAmt

                    }


                    var item = <PoPurInvoiceDtRow>{
                        LineItemNo: i,
                        SupplierId: po.SupplierId,
                        WhsId: po.WhsId,
                        SkuCode: po.SkuCode,
                        SkuDesc: po.SkuDesc,
                        Qty: po.Qty,
                        UnitChange: po.UnitChange,
                        PurUnit: po.PurUnit,
                        PurUnitPrice: po.PurUnitPrice,
                        LastPurUnitPrice: po.LastPurUnitPrice,
                        PurUnitRatio: po.PurUnitRatio,
                        Remark: po.Remark,
                        BeforeDiscAmt: po.BeforeDiscAmt,
                        DiscText: po.DiscText,
                        DiscAmt: po.DiscAmt,
                        ItemAmt: po.ItemAmt,
                        AlocalteDiscAmt: po.AlocalteDiscAmt,//////                        
                        ItemNetAmt: po.ItemNetAmt,
                        VatType: po.VatType,

                        VatCode: vatcode,
                        VatRate: vatrate,
                        ItemVatAmt: vat,
                        ItemExVatAmt: exvat,
                        ExpDate: po.ExpDate,


                    };

                    this.sumaloamt = sum
                    var id = this.getNextId();
                    //console.log("get id: " + this.getIdProperty());
                    item[this.getIdProperty()] = id;
                    this.view.addItem(item);
                }
                this.refresh();
            }
        }

        set DisAlocate(value: number) {
            if (this._disamt != value) {
                console.log("disamt: " + value);
                var row = this.view.getRows();
                this.clearDataGrid();
                var i = 0;
                console.log(this.totalamt + ":total")
                var sum = 0;

                for (var po of row) {
                    i++;
                    let alo = 0;
                    let amt = (po.BeforeDiscAmt - po.DiscAmt)
                    let Alocate = (amt * value) / (this.totalamt || 1);
                    sum = sum + Alocate

                    if (sum > value) {
                        alo = Alocate - (sum - value)
                    } else { alo = Alocate }

                    let netamt = po.ItemAmt - alo;
                    // let vat = amt*(po.VatRate/100);//vat Ex
                    var vat = 0.00;
                    var exvat = 0.00;
                    if (this.salevattype == "I") {
                        vat = (netamt * po.VatRate) / (100 + po.VatRate);
                        exvat = netamt - vat;
                    } else {
                        vat = netamt * (po.VatRate / 100);
                        exvat = netamt;
                    }

                    var item = <PoPurInvoiceDtRow>{
                        LineItemNo: i,
                        SupplierId: po.SupplierId,
                        WhsId: po.WhsId,
                        SkuCode: po.SkuCode,
                        SkuDesc: po.SkuDesc,
                        Qty: po.Qty,
                        UnitChange: po.UnitChange,
                        PurUnit: po.PurUnit,
                        PurUnitPrice: po.PurUnitPrice,
                        LastPurUnitPrice: po.LastPurUnitPrice,
                        PurUnitRatio: po.PurUnitRatio,
                        Remark: po.Remark,
                        BeforeDiscAmt: po.BeforeDiscAmt,
                        DiscText: po.DiscText,
                        DiscAmt: po.DiscAmt,
                        ItemAmt: amt,
                        AlocalteDiscAmt: alo,//////                        
                        ItemNetAmt: netamt,
                        VatType: po.VatType,
                        VatCode: po.VatCode,
                        VatRate: po.VatRate,

                        ItemVatAmt: vat,
                        ItemExVatAmt: exvat,

                        ExpDate: po.ExpDate,


                    };

                    this.sumaloamt = sum
                    var id = this.getNextId();
                    //console.log("get id: " + this.getIdProperty());
                    item[this.getIdProperty()] = id;
                    this.view.addItem(item);
                }
                // if (this.sumaloamt >  value){
                //     let x = this.view.getItem(i)
                //     x.AlocalteDiscAmt = x.AlocalteDiscAmt-(this.sumaloamt-value)
                // }
                // if (this.sumaloamt <  value){
                //     let x = this.view.getItem(i)
                //     x.AlocalteDiscAmt = x.AlocalteDiscAmt+(value -this.sumaloamt)
                // }

                this.refresh();
            }
        }

        set Vatchange(value: string) {
            if (this._vat != value) {
                console.log("disamt: " + value);
                var row = this.view.getRows();
                this.clearDataGrid();
                var i = 0;
                var sum = 0;

                for (var po of row) {
                    i++;
                    var vatrate = 0.00;
                    var vatcode = '';
                    var vat = 0
                    var exvat = 0

                    if (po.VatType != "N") {
                        vatcode = value
                        vatrate = Administration.CsVatCodeRow.getLookup().itemById[value].VatRate
                        if (this.salevattype == "I") {
                            vat = (po.ItemNetAmt * po.VatRate) / (100 + po.VatRate);
                            exvat = po.ItemNetAmt - vat;
                        } else {
                            vat = po.ItemNetAmt * (po.VatRate / 100);
                            exvat = po.ItemNetAmt;
                        }
                    } else {
                        vatcode = po.VatCode
                        vatrate = po.VatRate
                        vat = po.ItemVatAmt
                        exvat = po.ItemExVatAmt

                    }


                    var item = <PoPurInvoiceDtRow>{
                        LineItemNo: i,
                        SupplierId: po.SupplierId,
                        WhsId: po.WhsId,
                        SkuCode: po.SkuCode,
                        SkuDesc: po.SkuDesc,
                        Qty: po.Qty,
                        UnitChange: po.UnitChange,
                        PurUnit: po.PurUnit,
                        PurUnitPrice: po.PurUnitPrice,
                        LastPurUnitPrice: po.LastPurUnitPrice,
                        PurUnitRatio: po.PurUnitRatio,
                        Remark: po.Remark,
                        BeforeDiscAmt: po.BeforeDiscAmt,
                        DiscText: po.DiscText,
                        DiscAmt: po.DiscAmt,
                        ItemAmt: po.ItemAmt,
                        AlocalteDiscAmt: po.AlocalteDiscAmt,//////                        
                        ItemNetAmt: po.ItemNetAmt,
                        VatType: po.VatType,

                        VatCode: vatcode,
                        VatRate: vatrate,
                        ItemVatAmt: vat,
                        ItemExVatAmt: exvat,
                        ExpDate: po.ExpDate,


                    };

                    this.sumaloamt = sum
                    var id = this.getNextId();
                    //console.log("get id: " + this.getIdProperty());
                    item[this.getIdProperty()] = id;
                    this.view.addItem(item);
                }
                this.refresh();
            }
        }

        set WhsId(value: string) {
            if (this._whsdt != value) {
                console.log("whsid: " + value);
                var row = this.view.getRows();
                this.clearDataGrid();
                var i = 0;
                console.log(this.totalamt)
                for (var po of row) {
                    i++;
                    var item = <PoPurInvoiceDtRow>{
                        LineItemNo: i,
                        SupplierId: po.SupplierId,
                        WhsId: value,
                        SkuCode: po.SkuCode,
                        SkuDesc: po.SkuDesc,
                        Qty: po.Qty,
                        UnitChange: po.UnitChange,
                        PurUnit: po.PurUnit,
                        PurUnitPrice: po.PurUnitPrice,
                        LastPurUnitPrice: po.LastPurUnitPrice,
                        PurUnitRatio: po.PurUnitRatio,
                        Remark: po.Remark,
                        BeforeDiscAmt: po.BeforeDiscAmt,
                        DiscText: po.DiscText,
                        DiscAmt: po.DiscAmt,
                        ItemAmt: po.ItemAmt,
                        AlocalteDiscAmt: po.AlocalteDiscAmt,
                        ItemNetAmt: po.ItemNetAmt,


                        VatType: po.VatType,
                        VatCode: po.VatCode,
                        VatRate: po.VatRate,

                        ItemVatAmt: po.ItemVatAmt,
                        ItemExVatAmt: po.ItemExVatAmt,

                        ExpDate: po.ExpDate,


                    };
                    var id = this.getNextId();
                    //console.log("get id: " + this.getIdProperty());
                    item[this.getIdProperty()] = id;
                    this.view.addItem(item);
                }

                this.refresh();
            }
        }

        public clearDataGrid() {
            this.view.setItems([], true);
        }


    }
}

